var $ = require('jquery');

$(function () {
    var $rteIconLinkElements = $('[class^="ws-rte-icon-link__"]');

    $.each($rteIconLinkElements, function (index, value) {
        this.innerHTML = '<span>' + $(this).text() + '</span>';
    });
})